import React, { useState } from 'react'
import { apiDelete } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function DeleteServiceRequirementModal({ isOpen, onClose, requirementData, GetUserAllRequirements }) {
    const [IsLoading, setIsLoading] = useState(false);
    const onDelete = async () => {

        try {
            setIsLoading(true);
            const response = await apiDelete(`/api/user/DeleteServiceRequirement/${requirementData?._id}`);
            toast.success(response?.message || "ServiceRequirement deleted successfully!");
            onClose()
            GetUserAllRequirements();
        } catch (error) {
            console.error("Error updating ServiceRequirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;
    return (
        <div>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Delete ServiceRequirement
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Are you sure you want to delete this ServiceRequirement? This action cannot be undone.
                    </p>

                    <div className="flex justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onDelete}
                            disabled={IsLoading}
                            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default DeleteServiceRequirementModal